import {
  compose,
  equals,
  filter,
  length,
  path,
  pathOr,
  prop,
  reject,
  unless,
  when,
} from 'ramda';
import { createSelector } from 'reselect';

import {
  GAME_ROOM_KEY, SUPPORT_ROOM_KEY, ROOM, PRESENCE,
} from '../constants/chat';
import { MessageType, RootStateWithChatLoaded } from '../reducers/chat';
import { chatConfigSelector } from './config';
import { minBetSelector } from './game';
import { userBalanceSelector, userSelector } from './user';

export const userCanChatSelector = createSelector(
  userBalanceSelector,
  minBetSelector,
  (balance, minBet) => balance >= minBet,
);

export const chatSelector = (state: RootStateWithChatLoaded) => state?.chat;

export const boshConnectionStatusSelector = createSelector(
  chatSelector,
  path([ 'boshConnectionStatus' ])
);

export const chatUsernameSelecor = createSelector(
  chatSelector,
  (chat) => chat?.supportTicket.username as string
);

export const supportTicketSelector = createSelector(
  chatSelector,
  // eslint-disable-next-line max-len
  (state) => state?.supportTicket,
);

export const isChatMutedSelector = createSelector(
  chatSelector,
  prop('mute')
);

export const roomMessagesSelector = createSelector(
  chatSelector,
  userSelector,
  (chat, user) => compose(
    when(() => chat?.mute, filter(({ name }) => name === user.nickname)),
    pathOr([], [ GAME_ROOM_KEY, 'messages' ])
  )(chat)
);

export const supportMessagesSelector = createSelector(
  chatSelector,
  path([ SUPPORT_ROOM_KEY, 'messages' ])
);

const shouldShowPresence = (config: any) => () => prop('showPlayerPresence')(config);

const isPresenceMessage = compose(
  equals(PRESENCE),
  prop('type')
);

export const chatMessagesSelector = (type: string) => createSelector(
  chatConfigSelector,
  (state: RootStateWithChatLoaded) => (type === ROOM ? roomMessagesSelector(state) : supportMessagesSelector(state)),
  (config, messages) => compose<any, MessageType[]>(
    unless(shouldShowPresence(config), reject(isPresenceMessage)),
  )(messages)
);

export const unreadSupportMessagesCountSelector = createSelector(
  chatSelector,
  // @ts-ignore
  compose(
    length,
    // @ts-ignore
    filter((m) => m.unread),
    pathOr([], [ SUPPORT_ROOM_KEY, 'messages' ])
  )
);

export const chatErrorSelector = createSelector(
  chatSelector,
  (chat) => chat.error ?? false
);

export const chatLoadingSelector = createSelector(
  chatSelector,
  prop('loading')
);
